<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import { eventBus} from './main'
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  computed: {
      ...mapGetters({
          venueId: "venueId"
      }),
  },
  created() {
    // TBD: PXLT-7522
    mixpanel.register_once({
        "VenueID": this.venueId
    });
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue